import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { FormGroup } from '../data/form-group';
import { BodyFormGroup } from '../body/body-form-group';
import { Value } from '../data/value';

@Injectable({
  providedIn: 'root'
})
export class FormGroupService {
  private http = inject(HttpClient);

  controllerURL = '/api/form-groups';

  getFormGroups(): Observable<FormGroup[]> {
    return this.http.get<FormGroup[]>(environment.apiUrl + this.controllerURL);
  }

  getFormGroup(id: string): Observable<FormGroup> {
    return this.http.get<FormGroup>(environment.apiUrl + this.controllerURL + '/' + id);
  }

  getFormGroupForUser(id: string): Observable<FormGroup> {
    return this.http.get<FormGroup>(environment.apiUrl + this.controllerURL + '/' + id + '/user-view');
  }

  getFormGroupIdByTag(tag: string): Observable<Value> {
    return this.http.get<Value>(environment.apiUrl + this.controllerURL + '/tag/' + tag);
  }

  createFormGroup(body: BodyFormGroup): Observable<string> {
    return this.http.post<string>(environment.apiUrl + this.controllerURL, body);
  }

  updateFormGroup(id: string, body: BodyFormGroup): Observable<void> {
    return this.http.put<void>(environment.apiUrl + this.controllerURL + '/' + id, body);
  }

  deleteFormGroup(id: string): Observable<void> {
    return this.http.delete<void>(environment.apiUrl + this.controllerURL + '/' + id);
  }
}
